// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content-wrapper[data-v-31530ee2] {
  box-sizing: border-box;
  width: min(585px, calc(100vw - 64px));
  padding: 14px 0;
  overflow-x: hidden;
  overflow-wrap: anywhere;
  text-align: center;
  color: #5f6b71;
}
[data-v-31530ee2] .header-text {
  color: #125471;
  font-weight: 500;
}
[data-v-31530ee2] .modal-divider {
  width: calc(100% - 32px);
  margin: 0 16px;
  border-top-color: #e9ebec;
}
.referral-header[data-v-31530ee2] {
  font-size: 26px;
}
.referral-text[data-v-31530ee2] {
  color: #125471;
  text-align: left;
}
.referral-image[data-v-31530ee2] {
  width: 409px;
  max-width: 100%;
  height: auto;
}
.oplus-modal-btn[data-v-31530ee2] {
  width: 118px;
  color: #fff;
  background-color: #f06dc4da;
  border: none;
}
.oplus-modal-btn[data-v-31530ee2]:hover {
  background-color: #F06DC5;
}
@media (max-width: 600px) {
.referral-header[data-v-31530ee2] {
    font-size: 20px;
}
}
`, "",{"version":3,"sources":["webpack://./src/vue/ReferralAdModal.vue"],"names":[],"mappings":";AAiEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,yBAAyB;AAC3B;AAEA;EACE,eAAe;AACjB;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,YAAY;AACd;AAEA;EACE,yBAAyB;AAC3B;AAEA;AACE;IACE,eAAe;AACjB;AACF","sourcesContent":["<script setup lang=\"ts\">\nimport { ref } from 'vue';\nimport { useI18n } from 'vue-i18n';\nimport Modal from './Modal.vue';\n\nconst { t } = useI18n();\nconst isVisible = ref(false);\n\nconst props = defineProps({\n  branchId: {\n    type: Number,\n    required: true,\n  },\n  userId: {\n    type: Number,\n    required: true,\n  },\n})\n\nfunction closeModal() {\n  isVisible.value = false;\n}\n\nfunction openModal() {\n  isVisible.value = true;\n}\n\nfunction openReferralPage() {\n  window.location.href = `/dashboard/${props.userId}/referral?c=${props.branchId}`;\n}\n\ndefineExpose({\n  openModal,\n  closeModal,\n});\n</script>\n\n<template>\n  <Modal v-if=\"isVisible\" @close-modal=\"closeModal\" :has-title-divider=\"true\" :has-footer-divider=\"true\">\n    <template v-slot:header-title>\n      {{ t('dash.nav.referral') }}\n    </template>\n    <template v-slot:content>\n      <div class=\"content-wrapper\">\n        <div class=\"referral-header\">{{ t('referral.header') }}</div>\n        <img\n          class=\"referral-image\"\n          src=\"https://storage.googleapis.com/opluswork.com/dashboard/registration-banner.jpg\"\n          alt=\"\"\n        />\n        <div class=\"referral-text\">\n          {{ t('referral.subtitle_line1') }}<br>\n          {{ t('referral.subtitle_line2') }}\n        </div>\n      </div>\n    </template>\n    <template v-slot:footer-btn>\n      <button class=\"oplus-modal-btn\" type=\"button\" @click=\"openReferralPage\">\n        {{ t('referral.learn_more') }}\n      </button>\n    </template>\n  </Modal>\n</template>\n\n<style scoped>\n.content-wrapper {\n  box-sizing: border-box;\n  width: min(585px, calc(100vw - 64px));\n  padding: 14px 0;\n  overflow-x: hidden;\n  overflow-wrap: anywhere;\n  text-align: center;\n  color: #5f6b71;\n}\n\n:deep(.header-text) {\n  color: #125471;\n  font-weight: 500;\n}\n\n:deep(.modal-divider) {\n  width: calc(100% - 32px);\n  margin: 0 16px;\n  border-top-color: #e9ebec;\n}\n\n.referral-header {\n  font-size: 26px;\n}\n\n.referral-text {\n  color: #125471;\n  text-align: left;\n}\n\n.referral-image {\n  width: 409px;\n  max-width: 100%;\n  height: auto;\n}\n\n.oplus-modal-btn {\n  width: 118px;\n  color: #fff;\n  background-color: #f06dc4da;\n  border: none;\n}\n\n.oplus-modal-btn:hover {\n  background-color: #F06DC5;\n}\n\n@media (max-width: 600px) {\n  .referral-header {\n    font-size: 20px;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
